import { Text, Tooltip } from '@billy/design-system'

import { useIsTruncated } from '../../../../hooks'

interface TruncatedTextProps {
  text: string
}

export const TruncatedText = ({ text }: TruncatedTextProps) => {
  const [textRef, isTruncated] = useIsTruncated(text)

  const textElement = (
    <Text truncate ref={textRef}>
      {text}
    </Text>
  )

  return isTruncated ? (
    <Tooltip label={text} placement="top">
      {textElement}
    </Tooltip>
  ) : (
    textElement
  )
}
